"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformDateToMonthNameString = void 0;
const monthNames_1 = require("../utils/monthNames");
function transformDateToMonthNameString(date) {
    return monthNames_1.monthNames[date.getUTCMonth()];
}
exports.transformDateToMonthNameString = transformDateToMonthNameString;
//# sourceMappingURL=transformDateToMonthNameString.js.map